import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'
import BusinessTypeModel from '@/shared/models/configuration/businesstypemodel'
import BusinessTypeForms from './businesstype-form'

export default {
  name: 'BusinessType',
  mixins: [ActionsForm],
  data () {
    return {
      data: BusinessTypeModel,
      form: BusinessTypeForms,
      polling: null
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      BusinessTypeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      // --> Set manual
      this.onChangeArea()
      this.polling = setInterval(() => {
        this.setInsurance(obj.insuranceID)
      }, 500)
      loading.pop()
    },
    onCreate () {
      loading.push()
      BusinessTypeRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      BusinessTypeRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      BusinessTypeRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllInsurer (id) {
      this.form.insuranceID.options = []
      if (id) {
        loading.push()
        InsuranceRepository.GetAllByAreaID(id)
          .then((response) => {
            this.form.insuranceID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeArea () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllInsurer(self.form.areaID.value)
      }, 500)
    },
    setInsurance (insuranceID) {
      if (insuranceID) {
        var options = this.form.insuranceID.options
        if (options.length > 0) {
          clearInterval(this.polling)
          this.form.insuranceID.value = insuranceID
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/businesstype/businesstype.js